import { PROJECTS_REDUCER_KEYS as KEYS } from '../reducers/projectsReducerKeys'

export const getProjectCenter = (state, serverID) => {
  return state.getIn([KEYS.PROJECTS, KEYS.CENTER_BY_ID, serverID])
}
